const state = {
  info: {
    termsAccepted: null,
    studentSie: '',
    birthDay: '',
    birthMonth: '',
    birthYear: '',
    selectedNotificationWay: null,
  },
  catalog: {
    notificationWays: [],
  },
  confirmationNumber: '',
  wasStudentValidated: null,
  wasStudentValidatedMessage: null,
  questionnaire: [],
};

export default state;
